import { createContext, useEffect, useReducer } from "react";

import axios from "../utils/axios";
import SmsTemplateReducer from "../reducers/SmsTemplateReducer";
import { isValidToken, setSession } from "../utils/jwt";
import { SmsTemplateConstants } from "../constants/index";
import { saveFile } from "../utils/common";
const initialState = {
  smsTemplates: [],
  paging: {
    totalNumberOfRecords: 0,
    totalNumberOfPages: 0,
    pageNumber: 0,
    pageSize: 0,
  },
  hasError: false,
  errorMessage: "",
  smstemplateSearchResults: [],
  smstemplate: {},
  isUpload: false,
  uploadError: false,
  uploadSuccess: false,
  isLoading: true,
  isLoadingDownload: false,
  smsTemplateAutoSearchResults: {
    data: [],
    paging: {
      hasNextPage: false,
      hasPreviousPage: false,
      pageNumber: 0,
      pageSize: 0,
      totalNumberOfPages: 0,
      totalNumberOfRecords: 0,
    },
  },
  autoSearchLoading: false,
  isLoadingAutoSearch: true,
  downloadFileType: "",
};
const initPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

const SmsTemplateContext = createContext({
  ...initialState,
  getAllSmsTemplate: () => {},
  addSmsTemplate: () => {},
  searchSmsTemplate: () => {},
  getSmsTemplate: () => {},
  updateSmsTemplate: () => {},
  downloadFile: () => {},
  sampleFile: () => {},
  uploadFile: () => {},
  autoSearchSmsTemplate: () => {},
});

function SmsTemplateProvider({ children }) {
  const [state, dispatch] = useReducer(SmsTemplateReducer, initialState);

  const getAllSmsTemplate = async (payload) => {
    try {
      dispatch({
        type: SmsTemplateConstants.FETCH_SMSTEMPLATE_REQUEST,
      });
      const response = await axios.post("/master/sms-template/list", payload);

      dispatch({
        type: SmsTemplateConstants.FETCH_SMSTEMPLATE_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: SmsTemplateConstants.FETCH_SMSTEMPLATE_FAILURE,
      });
    }
  };
  const searchSmsTemplate = async () => {
    try {
      const response = await axios.post("/master/sms-template/search", initPayload);
      dispatch({
        type: SmsTemplateConstants.SMSTEMPLATE_SEARCH_REQUEST,
      });
      console.log(response.data, "response.data");
      dispatch({
        type: SmsTemplateConstants.SMSTEMPLATE_SEARCH_SUCCESS,
        payload: response.data,
      });
    } catch (exception) {
      dispatch({
        type: SmsTemplateConstants.SMSTEMPLATE_SEARCH_FAILURE,
      });
    }
  };
  const addSmsTemplate = async (payload) => {
    const response = await axios.post("/master/sms-template/add", payload);
    dispatch({
      type: SmsTemplateConstants.ADD_SMSTEMPLATE_REQUEST,
    });
    dispatch({
      type: SmsTemplateConstants.ADD_SMSTEMPLATE_SUCCESS,
      payload: response.data,
    });
  };

  const getSmsTemplate = async (id) => {
    const response = await axios.get("/master/sms-template/" + id);
    dispatch({
      type: SmsTemplateConstants.GET_SMSTEMPLATE_REQUEST,
    });
    dispatch({
      type: SmsTemplateConstants.GET_SMSTEMPLATE_SUCCESS,
      payload: response.data,
    });
  };

  const updateSmsTemplate = async (payload) => {
    const response = await axios.put(
      "/master/sms-template/update/" + payload.smsTemplateId,
      payload,
    );
    dispatch({
      type: SmsTemplateConstants.UPDATE_SMSTEMPLATE_REQUEST,
    });
    dispatch({
      type: SmsTemplateConstants.UPDATE_SMSTEMPLATE_SUCCESS,
      payload: response.data,
    });
  };

  const downloadFile = async (fileType, payload) => {
    dispatch({
      type: SmsTemplateConstants.DOWNLOAD_SMSTEMPLATE_REQUEST,
      payload: {
        fileType: fileType,
      },
    });
    const response = await axios.post("/master/sms-template/export/" + fileType, payload, {
      responseType: "blob",
    });
    console.log(response.headers, "filename");
    //const filename = response.headers.get("content-disposition").split('"');

    await saveFile(response.data, "smstemplate." + fileType);

    dispatch({
      type: SmsTemplateConstants.DOWNLOAD_SMSTEMPLATE_SUCCESS,
      payload: response.data,
    });
  };

  const sampleFile = async (fileType) => {
    const response = await axios.get("/master/sms-template/sample/" + fileType, {
      responseType: "blob",
    });

    await saveFile(response.data, "sample_sms-template." + fileType);
    dispatch({
      type: SmsTemplateConstants.DOWNLOAD_SMSTEMPLATE_REQUEST,
    });
    dispatch({
      type: SmsTemplateConstants.DOWNLOAD_SMSTEMPLATE_SUCCESS,
      payload: response.data,
    });
  };

  const uploadFile = async (payload) => {
    try {
      dispatch({
        type: SmsTemplateConstants.UPLOAD_SMSTEMPLATE_REQUEST,
      });
      const response = await axios({
        url: "/master/sms-template/upload",
        method: "POST",
        data: payload,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      dispatch({
        type: SmsTemplateConstants.UPLOAD_SMSTEMPLATE_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      console.log("errr", error);
      dispatch({
        type: SmsTemplateConstants.UPLOAD_SMSTEMPLATE_FAILURE,
      });
    }
  };

  const autoSearchSmsTemplate = async (payload) => {
    try {
      const response = await axios.post("/master/sms-template/auto-search", payload);
      dispatch({
        type: SmsTemplateConstants.SMSTEMPLATE_AUTO_SEARCH_REQUEST,
      });
      dispatch({
        type: SmsTemplateConstants.SMSTEMPLATE_AUTO_SEARCH_SUCCESS,
        payload: response.data,
      });
    } catch (exception) {
      dispatch({
        type: SmsTemplateConstants.SMSTEMPLATE_AUTO_SEARCH_FAILURE,
      });
    }
  };

  return (
    <SmsTemplateContext.Provider
      value={{
        ...state,
        getAllSmsTemplate,
        addSmsTemplate,
        searchSmsTemplate,
        getSmsTemplate,
        updateSmsTemplate,
        downloadFile,
        sampleFile,
        uploadFile,
        autoSearchSmsTemplate,
      }}
    >
      {children}
    </SmsTemplateContext.Provider>
  );
}

export { SmsTemplateContext, SmsTemplateProvider };
